/**
 * Force d'un paysage naturel pour chaque intention.
 * 3 = très adapté, 2 = adapté, 1 = possible.
 */
export const NATURALS_AFFINITY = Object.freeze({
  bruit: {
    strength: { relax: 1, rest: 3, recenter: 3 },
    pairsWell: ["mer", "ruisseau", "pluie"],
  },
  oiseaux: {
    strength: { relax: 3, recenter: 2 },
    pairsWell: ["ruisseau", "criquets"],
  },
  ruisseau: {
    strength: { relax: 3, rest: 2, recenter: 2 },
    pairsWell: ["oiseaux", "feu", "pluie"],
  },
  mer: {
    strength: { relax: 3, rest: 2, recenter: 1 },
    pairsWell: ["mouette", "tonnerre"],
  },
  feu: {
    strength: { relax: 2, rest: 3, recenter: 1 },
    pairsWell: ["pluie", "ruisseau", "chat"],
  },
  pluie: {
    strength: { relax: 2, rest: 3, recenter: 1 },
    pairsWell: ["feu", "tonnerre", "train"],
  },
  tonnerre: {
    strength: { relax: 1, rest: 2 },
    pairsWell: ["pluie", "mer"],
  },
  criquets: {
    strength: { relax: 3, rest: 2, recenter: 2 },
    pairsWell: ["feu", "owl"],
  },
  train: {
    strength: { relax: 2, rest: 3, recenter: 1 },
    pairsWell: ["pluie"],
  },
  bol: {
    strength: { relax: 3, rest: 1, recenter: 2 },
    pairsWell: ["ruisseau"],
  },
  mouette: {
    strength: { relax: 2, recenter: 1 },
    pairsWell: ["mer"],
  },
  fan: {
    strength: { relax: 1, rest: 3, recenter: 3 },
    pairsWell: ["bruit", "pluie"],
  },
  toundra: {
    strength: { relax: 3, rest: 2, recenter: 1 },
    pairsWell: ["owl", "tonnerre"],
  },
  baleine: {
    strength: { relax: 2, rest: 3 },
    pairsWell: ["mer"],
  },
  owl: {
    strength: { relax: 1, rest: 2 },
    pairsWell: ["criquets", "toundra"],
  },
  chat: {
    strength: { relax: 3, rest: 3 },
    pairsWell: ["pluie", "feu"],
  },
});

export function getCandidateNaturals(intent, naturalSounds, isPremium) {
  return (naturalSounds || [])
    .filter((sound) => isPremium || !sound.premium)
    .map((sound) => {
      const meta = NATURALS_AFFINITY[sound.id];
      return {
        ...sound,
        strength: meta?.strength?.[intent] || 0,
        pairsWell: meta?.pairsWell || [],
      };
    })
    .filter((sound) => sound.strength > 0);
}
